export default __webpack_public_path__ + "static/Appeal-Pages-2-54efad7f80981da5535f74fc6c74b636.jpg";